export { default as Navbar } from './Navbar';
export { default as Main } from './main';
export { default as Product } from './Products';
export { default as Footer } from './Footer';
export { default as Category } from './Category';
export { default as Reviews } from './Reviews';